<div class="form-row">
    <div class="form-group mb-0">
        <div class="col-xs-12">
            <hr class="panel-options-divider" />
        </div>
    </div>
</div>

<div class="title">
    {{ "widget_product_settings_counter" | translate | uppercase }}
</div>

<div class="form-row">
    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_fields_name" | translate }}
        </label>
        <div class="col-xs-3 text-right control-switch">
            <sp-switch [active]="showLabels.value" (toggleActiveEvent)="setIsShowFieldsName($event)"></sp-switch>
        </div>
    </div>

    @if (showLabels.value) {
        <div class="form-group mb-20">
            <label class="col-xs-9 control-label">
                {{ "control_label_color" | translate }}
            </label>
            <div class="col-xs-3">
                <sp-color-picker
                    [hideGradient]="true"
                    [colorsPreset]="selectedThemeColors()"
                    [color]="textColor.value"
                    (colorChangeEvent)="setTextColor($event)"
                ></sp-color-picker>
            </div>
        </div>
    }
    <div class="form-group mb-20">
        <label class="col-xs-12">
            {{ "control_fields_appearance" | translate }}
        </label>
        <div class="col-xs-12">
            <div class="btn-group d-flex">
                <button
                    class="btn btn-grey w-100"
                    [class.active]="inputBorderType.value === InputBorderEnum.FULL_BORDER"
                    (click)="setInputBorderType(InputBorderEnum.FULL_BORDER)"
                >
                    <img src="./assets/img/websites/lpc-full-border-icon.svg" alt="center-icon" />
                </button>
                <button
                    class="btn btn-grey w-100"
                    [class.active]="inputBorderType.value === InputBorderEnum.BOTTOM_BORDER"
                    (click)="setInputBorderType(InputBorderEnum.BOTTOM_BORDER)"
                >
                    <img src="./assets/img/websites/lpc-bottom-border-icon.svg" alt="left-icon" />
                </button>
            </div>
        </div>
    </div>
    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_input_text_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [hideGradient]="true"
                [colorsPreset]="selectedThemeColors()"
                [color]="inputTextColor.value"
                (colorChangeEvent)="setInputTextColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_background_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [color]="backgroundColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setThemeBackgroundColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-9 control-label">
            {{ "control_border_color" | translate }}
        </label>
        <div class="col-xs-3">
            <sp-color-picker
                [hideGradient]="true"
                [color]="borderColor.value"
                [colorsPreset]="selectedThemeColors()"
                (colorChangeEvent)="setBorderColor($event)"
            ></sp-color-picker>
        </div>
    </div>

    <div class="form-group mb-20">
        <label class="col-xs-6 control-label">
            {{ "control_radius" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-input-num
                prefixImgUrl="./assets/img/border-radius-icon.svg"
                suffixText="px"
                [class.disabled]="isDisabled"
                [min]="BORDER_RADIUS_MIN"
                [max]="BORDER_RADIUS_MAX"
                [value]="borderRadius.value"
                (valueChange)="setBorderRadius($event)"
                (blurEvent)="setBorderRadius($event)"
            ></sp-input-num>
        </div>
    </div>

    <div class="form-group mb-0">
        <label class="control-label col-xs-6">
            {{ "control_fields_size" | translate }}
        </label>
        <div class="col-xs-6">
            <sp-radio-group
                [selected]="inputSize.value"
                [type]="ERadioGroupType.size"
                (changeSelectedEvent)="setInputSize($event)"
            ></sp-radio-group>
        </div>
    </div>
</div>
